import React from 'react';
import PropTypes from 'prop-types';
import './Question.scss';
var hideQuestionSubtext = function hideQuestionSubtext(questionKey, onboarding) {
  return onboarding && questionKey === 'education';
};
var hideQuestionText = function hideQuestionText(questionKey, onboarding) {
  if (onboarding) {
    return ['education', 'functional_areas', 'therapeutic_areas'].includes(questionKey);
  }
  return false;
};
var designType = function designType(questionKey, location) {
  if (location === 'proposal-edit') return 'new-design proposal-edit';
  return 'new-design profile-edit';
};
function Question(props) {
  var title = props.title,
    subtext = props.subtext,
    className = props.className,
    children = props.children,
    error = props.error,
    disabled = props.disabled,
    questionKey = props.questionKey,
    isParent = props.isParent,
    location = props.location;
  var onboardingQuestionnaire = location === 'onboarding';
  var headerStyle = ['availability', 'available_when'].includes(questionKey) ? 'availability-header' : "header ".concat(onboardingQuestionnaire ? 'onboarding-header' : 'profile-header', " mb-8");
  var designTypeStyle = designType(questionKey, location);
  return /*#__PURE__*/React.createElement("div", {
    className: "question ".concat(designTypeStyle, " ").concat(className, " ").concat(questionKey, " ").concat(disabled ? 'disabled-grey' : '', " ").concat(isParent ? 'parent' : '')
  }, error && /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), ' ', "Required!"), hideQuestionText(questionKey, onboardingQuestionnaire) ? null : title && /*#__PURE__*/React.createElement("div", {
    className: "".concat(headerStyle, " ").concat(error ? 'with-error-text' : '')
  }, title), hideQuestionSubtext(questionKey, onboardingQuestionnaire) ? null : subtext && /*#__PURE__*/React.createElement("div", {
    className: "description subtext ".concat(onboardingQuestionnaire ? 'onboarding-description' : '')
  }, subtext), onboardingQuestionnaire && questionKey === 'location' ? /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, ' ', /*#__PURE__*/React.createElement("strong", null, "City or postal code")) : null, children);
}
Question.propTypes = {
  title: PropTypes.string,
  subtext: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  questionKey: PropTypes.string,
  isParent: PropTypes.string,
  location: PropTypes.string
};
Question.defaultProps = {
  title: null,
  subtext: null,
  className: '',
  children: null,
  error: false,
  disabled: false,
  location: 'onboarding',
  questionKey: '',
  isParent: false
};
export default Question;